export default __webpack_public_path__ + "static/media/sp11.9c7acaa4.png";